import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SwitchOn from '../adminIcons/SwitchOn.svg'
import BackIcon from '../adminIcons/BackIcon.svg'
import SwitchOff from '../adminIcons/SwitchOff.svg'
import { getCategory, getCategoryTags, editCategory } from '../../actions/AdminCategoryActions';
import { useParams, useNavigate } from 'react-router-dom'
import CategoryTagItem from './CategoryTagItem';
import AddTagComponent from './AddTagComponent';
import Attach from '../adminIcons/Attach.svg'

const EditCategory = (props) => {

    const dispatch = useDispatch()
    const [imageFile, setImageFile] = useState()
    const [imageURL, setImageUrl] = useState()

    const navigate = useNavigate()

    const {category_id} = useParams()

    const {category, loadingCategory, errorCategory} = useSelector(state=>state.adminCategories)
    const {categoryTags, loadingCategoryTags, errorCategoryTags} = useSelector(state=>state.categoryTags)

    const [statusOn, setStatusOn] = useState(0)
    const [title, setTitle] = useState("")


    useEffect(()=>{
        dispatch(getCategory(category_id))
        dispatch(getCategoryTags(category_id))
    },[])

    useEffect(()=>{
        if(category){
            setTitle(category.title)
            setStatusOn(category.status)
        }
    }
    , [category])

    const backHandler = () => {
        if(props.changes){
            var answer = window.confirm("You may loose the changes you made");
            if(answer){
                props.setChanges(false)
                navigate(-1)
            }
        } else {
            navigate(-1)
        }
    }


        const handleImage = (e) => {
            setImageFile(e.target.files[0])
            let u = URL.createObjectURL(e.target.files[0])
            setImageUrl(u)
        }
    


    const editGroupHandler = () => {
        if(!title.length){
            alert('Please, Provide Title') 
        } else { 
            dispatch(editCategory(category_id, title, statusOn,imageFile ))
            navigate('/categories')
        }
    }

    return (
        <div className = "col-10 p-4" style={{marginLeft:"15vw", minHeight:"100vh"}}>   
            {
                loadingCategory ? <>loading...</> : category ? 
                <> 
                    <div className = "w-100 d-flex flex-column align-items-center pb-5">
                    <div className='col-9 d-flex align-items-center justify-content-start pb-4'>
                        <img 
                            src = {BackIcon} 
                            role = 'button'
                            onClick={backHandler}
                            alt = ""/>
                        <div className = "fw-bold fs-7 ps-4 text-secondary" 
                            role='button' 
                        >{category.title}</div>
                    </div>
                        <div className = "col-9 bg-success me-3 rounded px-3 py-5">
                            <div className = "text-secondary fw-bold pb-2">Title*</div>
                            <input
                                type="text"
                                className="col-12 rounded fs-5 border-0 bg-warning text-white py-3 search-input ps-3"
                                onChange = {(e)=>{setTitle(e.target.value); props.setChanges(true)}}
                                value = {title}
                            />
                            <div className='w-100 d-flex justify-content-center align-items-center pt-4'>
                                <div className = "">
                                    {
                                        <>
                                            <img 
                                                src = {imageFile && imageFile.name ? imageURL:`https://img.cugate.com/?o=CUTV_TAGICON&i=${category_id}&s=mega`} 
                                                alt = ""
                                                onError = {(e=>e.target.src = Attach)}
                                                style = {{width:"50px"}}
                                            />
                                            <div className = " d-flex justify-content-between align-items-center mt-3">
                                                {/* <div className = "text-info text-decoration-underline text-wrap overflow-hidden">{imageFile.name}</div> */}
                                                <input 
                                                    id = "reimage-input"
                                                    type="file" 
                                                    name="imageFile"
                                                    accept='image/jpeg, image/png, image/jpg, image/svg+xml'
                                                    onChange={handleImage}
                                                    style={{display:"none"}}
                                                    />
                                                    <label for="reimage-input">
                                                        <div 
                                                            className = "text-info bg-success rounded"
                                                            role='button'
                                                        >Change</div>
                                                    </label>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>

                            <div className = "text-secondary fw-bold pt-4 pb-2">Add Tags</div>
                            <AddTagComponent
                                category_id = {category_id}
                                tags = {categoryTags}
                            />

                            <div className = "text-secondary fw-bold pt-4 pb-2">Tags</div>
                            {
                                loadingCategoryTags ?
                                <div className = "w-100 d-flex justify-content-start align-items-center text-info fs-6">
                                    Loading...
                                </div> :
                                errorCategoryTags ?
                                <div className = "w-100 d-flex justify-content-start align-items-center text-info fs-6">
                                    {errorCategoryTags}
                                </div> :
                                0 === categoryTags.length ?
                                <div className = "w-100 d-flex justify-content-start align-items-center text-info fs-6">
                                    No Tags Found
                                </div> :  
                                <div className = "bg-warning w-100 rounded addToplaylist-list-wrapper" style = {{maxHeight:"500px"}}>
                                {  
                                    categoryTags && categoryTags.length ?
                                        categoryTags.map((tag, index)=>(
                                            <CategoryTagItem
                                                tag = {tag}
                                                category_id = {category_id}
                                                key = {tag.id}
                                            />
                                        )) : ""
                                }

                            </div>  
                            }
                            <div className = "py-4" role = "button">
                                {
                                    statusOn === 0 ? 
                                    <div className = "d-flex align-items-center">
                                        <img src = {SwitchOff} alt = "" onClick={()=>{setStatusOn(1); props.setChanges(true)}}/>
                                        <div className = "text-info ms-4">Access OFF</div>
                                    </div>
                                     : 
                                     <div className = "d-flex align-items-center">
                                        <img src = {SwitchOn} alt = "" onClick={()=>{setStatusOn(0); props.setChanges(true)}}/>
                                        <div className = "text-info ms-4">Access ON</div>
                                    </div>
                                }
                            </div>
                            <div className = "w-100 d-flex justify-content-between">
                                <div 
                                    className = "text-white px-5 py-2 bg-secondary rounded-pill"
                                    role = "button"
                                    onClick = {()=>navigate(`/category/${category.title}/${category.id}`)}
                                >Show Videos</div>
                                <div 
                                    className = "text-white px-5 py-2 bg-secondary rounded-pill"
                                    role = "button"
                                    onClick = {()=>editGroupHandler()}
                                >Save</div>
                            </div>
                        </div>
                    </div>
                </> :                 
                <div className='w-100 h-100 d-flex justify-content-center align-items-center text-info fw-bold fs-4'>
                    There's Some Error, please, try again later
                </div>
            }
        </div>
    );
};

export default EditCategory;